import { Filter } from '@/interfaces/filter.interface'
import { APIProductKeyword } from '@/models/api/product-keyword.model'
import { ProductKeywordsServices } from '@/services/modules/product-keywords.service'
import store from '@/store'
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module
export default class ProductKeywordsStore extends VuexModule {
    productkeywords: object[] = []
    productkeywordsPaginate: object[] = []
    productkeywordForm: object|null = null

    @Mutation
    updateProductKeywords (newProductKeywords: object[]) {
        this.productkeywords = newProductKeywords
    }

    @Mutation
    updateProductKeywordsPaginate (newProductKeywords: object[]) {
        this.productkeywordsPaginate = newProductKeywords
    }

    @Mutation
    updateProductKeyword (newProductKeyword: object) {
        this.productkeywordForm = newProductKeyword
    }

    @Action
    getProductKeywords () {
        return new Promise((resolve) => {
            ProductKeywordsServices.getProductKeywords()
                .then(resp => {
                    store.commit('updateProductKeywords', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getProductKeywordsPaginate (params: { page: number; filters?: Filter[]; limit: number; sortBy: string; sort: string }) {
        return new Promise((resolve) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newParams: {[key: string]: any} = { page: params.page, limit: params.limit, sortBy: params.sortBy, sort: params.sort }

            if (params.filters) {
                params.filters.forEach((filter: Filter) => {
                    if (filter.queryValue) {
                        if (!newParams[filter.value]) {
                            newParams[filter.value] = filter.queryValue
                        } else {
                            let helper: string[] = []

                            if (Array.isArray(newParams[filter.value])) {
                                helper = [ ...newParams[filter.value] ]
                            } else {
                                helper.push(newParams[filter.value])
                            }

                            if (typeof filter.queryValue === 'string') helper.push(filter.queryValue)

                            newParams[filter.value] = helper
                        }
                    }
                })
            }

            ProductKeywordsServices.getProductKeywordsPaginate(newParams)
                .then(resp => {
                    store.commit('updateProductKeywordsPaginate', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    getProductKeywordsById (id: number) {
        return new Promise((resolve) => {
            ProductKeywordsServices.getProductKeywordsById(id)
                .then(resp => {
                    console.log(resp)
                    store.commit('updateProductKeyword', resp.data)
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    editProductKeywords (params: APIProductKeyword) {
        params = new APIProductKeyword(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIProductKeyword)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ProductKeywordsServices.editProductKeywords(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    createProductKeywords (params: APIProductKeyword) {
        params = new APIProductKeyword(params)

        return new Promise((resolve) => {
            if (!(params instanceof APIProductKeyword)) {
                store.commit('reportError', { code: 1000, message: 'Something went wrong :(' })
                resolve()
                return
            }

            ProductKeywordsServices.createProductKeywords(params)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    deleteProductKeywords (id: number) {
        return new Promise((resolve) => {
            ProductKeywordsServices.deleteProductKeywords(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }

    @Action
    restoreProductKeywords (id: number) {
        return new Promise((resolve) => {
            ProductKeywordsServices.restoreProductKeywords(id)
                .then(resp => {
                    resolve(resp)
                })
                .catch(error => {
                    resolve(error.response)
                })
        })
    }
}
